import {
  Calendar, Users, Receipt, Sparkles, Apple, Wallet, BarChart3, Megaphone,
  Dumbbell, HeartPulse, Bell, Mail, MessageCircle, CreditCard, Gift, Star,
  Clock, Camera, Trophy, ShieldCheck, Package, Target, Scissors, Stethoscope,
} from 'lucide-react';

export const MODULE_ICONS = {
  calendar: Calendar,
  users: Users,
  receipt: Receipt,
  sparkles: Sparkles,
  apple: Apple,
  wallet: Wallet,
  chart: BarChart3,
  megaphone: Megaphone,
  dumbbell: Dumbbell,
  heart: HeartPulse,
  bell: Bell,
  mail: Mail,
  message: MessageCircle,
  card: CreditCard,
  gift: Gift,
  star: Star,
  clock: Clock,
  camera: Camera,
  trophy: Trophy,
  shield: ShieldCheck,
  target: Target,
  scissors: Scissors,
  stethoscope: Stethoscope,
  package: Package,
};

export const MODULE_ICON_OPTIONS = Object.keys(MODULE_ICONS);

export const getModuleIcon = (key) => MODULE_ICONS[key] || Package;

export const MODULE_LANGS = [
  { code: 'de', label: 'DE' },
  { code: 'fr', label: 'FR' },
  { code: 'it', label: 'IT' },
  { code: 'en', label: 'EN' },
];

// Liefert Beschreibung + Vorteile eines Moduls in der gewünschten Sprache.
// Deutsch = Top-Level-Felder; FR/IT/EN aus m.translations[lang] mit Fallback auf Deutsch.
export const moduleText = (m, lang = 'de') => {
  if (!m) return { description: '', benefits: [] };
  if (lang === 'de' || !m.translations || !m.translations[lang]) {
    return { description: m.description || '', benefits: Array.isArray(m.benefits) ? m.benefits : [] };
  }
  const t = m.translations[lang] || {};
  return {
    description: t.description || m.description || '',
    benefits: (Array.isArray(t.benefits) && t.benefits.length ? t.benefits : (m.benefits || [])),
  };
};
